module.exports = {
  BASE_URL: BASE_URL,

  auth: BASE_URL + "auth/",
  clearToken: BASE_URL + "auth/clear-token/",
  authCheck: BASE_URL + "auth/check/",
  authCheckWithToken: BASE_URL + "auth/check-with-token/",
  authLogout: BASE_URL + "auth/logout/",
  authGetPermissions: BASE_URL + "auth/permissions/",

  menu:{
    otros: BASE_URL + "menu/otros",
  },

  // dashboard: {
  //   stats: BASE_URL + "dashboard/stats/",
  // },

  usuarios: {
    perfil: BASE_URL + "usuarios/perfil/",
    usuarios: BASE_URL + "usuarios/usuarios/",
    permisos: BASE_URL + "usuarios/permisos/",
    grupos: BASE_URL + "usuarios/grupos/",
  },

  empresas:{
    empresas: BASE_URL + "gestion/empresas/",
  },

  consultador:{
    articulos: BASE_URL + "consultador/articulos",
    listasDePrecios: BASE_URL + "consultador/listasdeprecios/",
    detail: BASE_URL + "consultador/articulo/detail",
    configConsultador: BASE_URL + "consultador/config/",
  },

  gestion:{
    fechaUltimaModificacion:BASE_URL + "gestion/core/fechaultimaactualizacion/",

    uploadImage:BASE_URL + "gestion/services/uploadImage/",
    updateOrder: BASE_URL + "gestion/core/updateorder/",

    articulos:{
      articulos: BASE_URL + "gestion/articulos/articulos/",
      articulosEditarMany: BASE_URL + "gestion/articulos/seleccion/editar/",
      destacados:{
        destacados: BASE_URL + "gestion/articulos/destacados/",
        articulos: BASE_URL + "gestion/articulos/destacados/articulos/",
      },
      ofertas:{
        ofertas: BASE_URL + "gestion/precios/ofertas/",
        articulos: BASE_URL + "gestion/precios/ofertas/articulos/",
      },
      categorias: BASE_URL + "gestion/articulos/categorias/",
      colores: BASE_URL + "gestion/articulos/colores/",
      coloresMostrarOcultar: BASE_URL + "gestion/articulos/colores/visibilidad/",
      talles: BASE_URL + "gestion/articulos/talles/",
      tallesMostrarOcultar: BASE_URL + "gestion/articulos/talles/visibilidad/",
      grupos: BASE_URL + "gestion/articulos/grupos/",
      gruposMostrarOcultar: BASE_URL + "gestion/articulos/grupos/visibilidad/",
      lineas: BASE_URL + "gestion/articulos/lineas/",
      lineasMostrarOcultar: BASE_URL + "gestion/articulos/lineas/visibilidad/",
      marcas: BASE_URL + "gestion/articulos/marcas/",
      materiales: BASE_URL + "gestion/articulos/materiales/",
      propiedades: BASE_URL + "gestion/articulos/propiedades/",
      rubros: BASE_URL + "gestion/articulos/rubros/",
      rubrosMostrarOcultar: BASE_URL + "gestion/articulos/rubros/visibilidad/",
      modelos: BASE_URL + "gestion/articulos/modelos/",
      proveedores: BASE_URL + "gestion/articulos/proveedores/",
      unidadmedida: BASE_URL + "gestion/articulos/unidadesmedida/",
    },
    stock:{
      stock: BASE_URL + "gestion/stock/stock/",
      depositos: BASE_URL + "gestion/stock/depositos/",
      sucursales: BASE_URL + "gestion/stock/sucursales/",
    },
    precios:{
      preciosEditarMany: BASE_URL + "gestion/precios/precios/seleccion/editar/",
      precios: BASE_URL + "gestion/precios/precios/",
      ficherolistas:BASE_URL + "gestion/precios/listasdeprecios/fichero/",
      listas: BASE_URL + "gestion/precios/listasdeprecios/",
      asignar: BASE_URL + "gestion/precios/consultadores/asignar",
      consultadores: BASE_URL + "gestion/precios/consultadores/"
    },
    cuentascorrientes:{
      movimientos: BASE_URL + "gestion/cuentascorrientes/movimientos/",
    },
    generales:{
      tiposdoc: BASE_URL + "gestion/generales/tiposdoc/",
      provincias:  BASE_URL + "gestion/generales/provincias/",
      localidades:  BASE_URL + "gestion/generales/localidades/",
      transportes: BASE_URL + "gestion/generales/transportes/",
      impuestos: BASE_URL + "gestion/generales/impuestos/",
      monedas: BASE_URL + "gestion/generales/monedas/",
      situacioniva: BASE_URL + "gestion/generales/situacioniva/",
    },
    ventas:{
      vendedores: {
        vendedores: BASE_URL + "gestion/ventas/vendedores/",
        vendedorHabilitarMovil:
        BASE_URL + "gestion/ventas/vendedores/habilitarmovil/",
        vendedorForceUpdate:
          BASE_URL + "gestion/ventas/vendedores/forceupdate/",
        vendedorNotificacion:
          BASE_URL + "gestion/ventas/vendedores/notificacion/"
      },
      clientes: BASE_URL + "gestion/ventas/clientes/",
      carritoCliente:BASE_URL + "gestion/ventas/clientes/carritos/",
      establecercarrito: BASE_URL + "gestion/ventas/clientes/clientes/establecercarrito/",
      pedidos: BASE_URL + "gestion/ventas/pedidos/",
      condicionesdepago: BASE_URL + "gestion/ventas/condicionesdepago/",
      condicionesdepagoMostrarOcultar: BASE_URL + "gestion/ventas/condicionesdepago/visibilidad/",
      tarjetas: BASE_URL + "gestion/ventas/tarjetas/",
    },
    sitio:{
      home: BASE_URL + "gestion/sitio/home/",
      carousel: BASE_URL + "gestion/sitio/carrusel/",
      novedades: BASE_URL + "gestion/sitio/novedades/",
      links: BASE_URL + "gestion/sitio/links/",
      logoEmpresa: BASE_URL + "gestion/sitio/logoempresa/",
    },
    core:{
      bitacoras: BASE_URL + "gestion/core/bitacoras/",
      configuracion: BASE_URL + "gestion/core/configuracion/",
    }
  },
  mails: {
    config: BASE_URL + "mails/configuracionmail/",
    plantillas: BASE_URL + "mails/plantillas/",
    casillas: BASE_URL + "mails/casillas/"
  },

  container: BASE_URL + "container/",
}



// WEBPACK FOOTER //
// ./src/api/api.js